<div class="snackbar-notification" [class]="containerClass">
  @switch (data.notificationType) {
    @case ('success') {
      <app-icon-circle-check-bold
        color="#047857"
      ></app-icon-circle-check-bold>
    }
    @case ('warning') {
      <app-icon-warning-triangle-bold
        color="#B78F41"
      ></app-icon-warning-triangle-bold>
    }
    @case ('error') {
      <app-icon-error-diamond-bold
      ></app-icon-error-diamond-bold>
    }
    @default {
      <app-icon-information-circle-bold
        color="#2F609F"
      ></app-icon-information-circle-bold>
    }
  }

  <p class="snackbar-notification__text">{{ data.text }}</p>
  <div matSnackBarActions class="ml-auto">
    <button
      matSnackBarAction
      class="snackbar-notification__close-btn"
      (click)="snackBarRef.dismissWithAction()"
      >
      OK
    </button>
  </div>
</div>
